module.exports = __webpack_public_path__ + "static/media/face-recognition.b1b65b0d.svg";